// Method 4 from http://www.javascriptkit.com/dhtmltutors/sticky-hover-issue-solutions.shtml#dynamichover

let isTouch = false; //variable to indicate current input type (is touch versus no touch)
let isTouchTimer: number;
let hoverStylesDisabled = false;

function disableHoverStyles(e: TouchEvent) {
	clearTimeout(isTouchTimer);

	isTouch = true;
	if (!hoverStylesDisabled) {
		hoverStylesDisabled = true;
		document.body.setAttribute('data-no-hover', '');
	}
	//maintain isIouch' state for 1000ms so enableHoverStyles doesn't get fired immediately following a touch event
	isTouchTimer = window.setTimeout(() => isTouch = false, 1000);
}

function enableHoverStyles(e: MouseEvent) {
	if (!isTouch && hoverStylesDisabled) {
		isTouch = false;
		hoverStylesDisabled = false;
		document.body.removeAttribute('data-no-hover');
	}
}

document.addEventListener('touchstart', disableHoverStyles, false); //this event only gets called when input type is touch
document.addEventListener('mouseover', enableHoverStyles, false); //this event gets called when input type is everything from touch to mouse/ trackpad
